import React, { useState } from "react";
import styles from "./FAQs.module.css";
import { useTranslation } from "../../I18n/Languages/LanguageContext";
import chevronLeft from "../../assets/arrow_red.svg";

const FAQsComponent = () => {
  const [openFAQs, setOpenFAQs] = useState([]);
  const { t } = useTranslation();

  const faqs = [
    {
      id: 0,
      question: t("questions1_FAQs"),
      answer: t("answers1_FAQs"),
    },
    {
      id: 1,
      question: t("questions2_FAQs"),
      answer: t("answers2_FAQs"),
    },
    {
      id: 2,
      question: t("questions3_FAQs"),
      answer: t("answers3_FAQs"),
    },
    {
      id: 3,
      question: t("questions4_FAQs"),
      answer: t("answers4_FAQs"),
    },
  ];

  const toggleFAQ = (id) => {
    setOpenFAQs((prevOpen) =>
      prevOpen.includes(id)
        ? prevOpen.filter((faqId) => faqId !== id)
        : [...prevOpen, id]
    );
  };

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.heading}>{t("faqs_title")}</h2>
      {faqs.map((faq) => (
        <div key={faq.id} className={styles.faqItem}>
          <div
            onClick={() => toggleFAQ(faq.id)}
            className={`${styles.faqHeader} ${
              openFAQs.includes(faq.id) ? styles.faqHeaderOpen : ""
            }`}
          >
            <span className={styles.faqQuestion}>{faq.question}</span>
            <div
              className={`${styles.icon} ${
                openFAQs.includes(faq.id) ? styles.iconOpen : ""
              }`}
            >
              <img
                src={chevronLeft}
                alt="chevron-right"
                width={20}
                height={20}
              />
            </div>
          </div>

          <div
            className={styles.faqAnswerWrapper}
            style={{
              maxHeight: openFAQs.includes(faq.id) ? "200px" : "0",
            }}
          >
            <div className={styles.faqAnswerContent}>{faq.answer}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQsComponent;
